module.exports = __webpack_public_path__ + "static/media/CSPORT LFT1M2 TURNTABLE.7ac74bb1.png";